export enum ReservationStatus {
  Pending = 1,
  Confirmed = 2,
  Cancelled = 3,
  Completed = 4,
}

export interface IReservationCategory {
  id: string;
  name: string;
  pricePerHour: number;
  isActive: boolean;
  earnsClashPoints: boolean;
  reservationCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateReservationCategory {
  name: string;
  pricePerHour: number;
  isActive?: boolean;
  earnsClashPoints?: boolean;
}

export interface IUpdateReservationCategory {
  name?: string;
  pricePerHour?: number;
  isActive?: boolean;
  earnsClashPoints?: boolean;
}

export interface ICourtReservation {
  id: string;
  courtId: string;
  courtName: string;
  userId: string;
  userName: string;
  startTime: string;
  endTime: string;
  status: ReservationStatus;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  guestName?: string | null;
  guestEmail?: string | null;
  guestPhone?: string | null;
  isGuest?: boolean;
  reservationCategoryId: string | null;
  reservationCategoryName: string | null;
  tournamentId?: string | null;
  tournamentName?: string | null;
  needBall: boolean;
  cost: number;
}

export interface ICreateReservationRequest {
  courtId: string;
  startTime: string;
  endTime: string;
  notes?: string;
  reservationCategoryId?: string;
  tournamentId?: string;
  status?: ReservationStatus;
  needBall?: boolean;
}

export interface IUpdateReservationRequest {
  startTime?: string;
  endTime?: string;
  status?: ReservationStatus;
  notes?: string;
  reservationCategoryId?: string;
  tournamentId?: string;
  needBall?: boolean;
}

export interface IRecurringTrainingRequest {
  courtId: string;
  startTime: string; // TimeOnly format "HH:mm:ss"
  endTime: string; // TimeOnly format "HH:mm:ss"
  dayOfWeek: number; // 0=Sunday, 1=Monday, ..., 6=Saturday
  startDate: string;
  endDate?: string;
  numberOfWeeks?: number;
  notes?: string;
  needBall?: boolean;
  reservationCategoryId?: string;
}

export interface ICategoryBreakdown {
  reservationCategoryId: string | null;
  categoryName: string;
  count: number;
  confirmedCount?: number;
  pendingCount?: number;
  hours: number;
  confirmedHours?: number;
  pendingHours?: number;
  revenue: number;
  confirmedRevenue?: number;
}

export interface IReservationReport {
  startDate: string;
  endDate: string;
  totalReservations: number;
  totalHours: number;
  totalRevenue: number;
  categoryBreakdown: ICategoryBreakdown[];
  statusBreakdown: Record<string, number>;
}
